<template>
  <div>
    <el-dialog :title="userHoliday.coachName+'的假期使用记录'" :visible.sync="selectHolidayDialog" width="1000px">
      <el-form label-position="top" ref="formRef" :model="userHoliday" label-width="110px">
        <el-tabs stretch  v-model="userHoliday.index" @tab-click="clickTab">
          <el-tab-pane v-for="(item,index) in userHoliday.holidayLibrary" :key="item.holidayRulesId" :disabled="item.limitBalance==0" :label="item.holidayRulesName" :name="index+''">
            <div style="display: flex;padding: 10px">
            <div style="overflow:auto;height: 420px;width: 45%;padding: 10px">
              <el-timeline>
                <div v-for="(activity, index) in item.logList" :key="index">
                  <el-timeline-item placement="top" :timestamp="activity.addTime">
                    <div style="background-color: #fafcff;padding: 8px 10px;border-radius: 8px">
                      <div v-if="activity.type == 0">
                        <div class="amount-add">+ {{activity.amount}}</div>
                        <div>{{activity.upCoachName}}增加:{{activity.amount}}天</div>
                        <div style="font-size: 13px;margin:4px 0 8px 0;">
                          {{activity.validStartTime}} 至 {{activity.validEndTime}}有效
                        </div>
                      </div>
                      <div v-if="activity.type == 1">
                        <div class="amount-minus">- {{activity.amount}}</div>
                        <div>{{activity.upCoachName}}减少:{{activity.amount}}天</div>
                        <div style="font-size: 13px;margin:4px 0 8px 0;">{{activity.validStartTime}} 至 {{activity.validEndTime}}有效</div>
                      </div>
                      <div v-if="activity.type == 2">
                        <div class="amount-minus">- {{activity.amount}}</div>
                        <div>{{userHoliday.coachName}}使用:{{activity.amount}}天</div>
                        <div style="font-size: 13px;margin:4px 0 8px 0;">
                          开始:{{activity.startTime}} 结束:{{activity.endTime}}
                        </div>
                      </div>
                      <div v-if="activity.type == 3">
                        <div class="amount-add">+ {{activity.amount}}</div>
                        <div>{{userHoliday.coachName}}申请了（销假申请）回退:{{activity.amount}}天</div>
                        <div style="font-size: 13px;margin:4px 0 8px 0;">
                          {{activity.startTime}} 至 {{activity.endTime}}
                        </div>
                      </div>
                      <div style="background-color: white;overflow:auto;height: 44px;padding: 6px;border-radius: 6px;font-size: 12px">
                        {{activity.type == 0 ? activity.upCoachName+':':''}}
                        {{activity.type == 1 ? activity.upCoachName+':':''}}
                        {{activity.description}}
                      </div>
                    </div>

                  </el-timeline-item>
                </div>
              </el-timeline>
            </div>
            <div style="width: 55%">
                <div style="text-align: center">
                  <span style="font-size: 34px;font-weight: bold">{{item.balance}}</span>
                  <span style="font-size: 15px;font-weight: bold">天</span>
                </div>
                <div class="update-holiday">
                  <div @click="updateHolidayDialog = !updateHolidayDialog" style="font-weight: bold;">修改{{item.holidayRulesName}}</div>
                  <el-collapse-transition>
                    <div v-show="updateHolidayDialog">
                      <div style="margin:20px 10px 0 10px;display:flex;align-items: center;">
                        <el-form-item
                            :prop="'holidayLibrary[' + index + '].type'" :rules="{required: true, message: '请选择', trigger: 'blur'}">
                          <el-select size="small" v-model="item.type" placeholder="请选择" style="width: 100px">
                            <el-option label="增加" :value="0"/>
                            <el-option label="减少" :value="1"/>
                          </el-select>
                        </el-form-item>
                        <el-form-item style="margin-left: 8px"
                                      :prop="'holidayLibrary[' + index + '].amount'" :rules="{required: true, message: '请输入', trigger: 'blur'}">
                          <el-input style="width: 100px;margin:0 2px 0 0px" size="small" v-model="item.amount" placeholder="请输入"></el-input> 天
                        </el-form-item>
                      </div>
                      <el-form-item style="margin-left: 8px"
                                    :prop="'holidayLibrary[' + index + '].desc'" :rules="{required: true, message: '请输入', trigger: 'blur'}">
                        <el-input v-model="item.desc" style="width: 100%;margin-top: 20px" :rows="4" type="textarea" placeholder="备注说明"/>
                      </el-form-item>
                      <div style="text-align: right; margin: 30px 10px 10px 0">
                        <el-button size="mini" @click="cancel()">取消</el-button>
                        <el-button type="danger" size="mini" @click="updateUserHoliday(index)">确定</el-button>
                      </div>
                    </div>
                  </el-collapse-transition>
                </div>
            </div>
          </div>
          </el-tab-pane>
        </el-tabs>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import {updateHolidayRemaining,selectHolidayRemainingStream} from '/src/api/attendance/holiday'
export default {
  name: "UpdateHolidayRemaining",
  data() {
    return {
      updateHolidayDialog:true,
      selectHolidayDialog:false,
      userHoliday:{
        holidayLibrary:[]
      },
    }
  },
  methods:{
    openDialog(item) {
      this.userHoliday = item;
      this.selectHolidayDialog = true;
      this.selectLog();
    },
    clickTab(val){
      this.userHoliday.index = val.index;
      this.selectLog();
    },
    cancel(){
      this.updateHolidayDialog = false;
    },
    selectLog(){
      let index = this.userHoliday.index;
      let query = this.userHoliday.holidayLibrary[index];
      query.index = index;
      query.coachId = this.userHoliday.coachId;

      selectHolidayRemainingStream(query).then(val=>{
        if (val.status==200){
          let index = this.userHoliday.index;
          this.userHoliday.holidayLibrary[index].logList = val.data.list;
          this.userHoliday = JSON.parse(JSON.stringify(this.userHoliday));
        }
      })
    },
    /**
     * 更新某个用户的假期余额
     */
    updateUserHoliday(index){
      this.$refs.formRef.validate(() => {
        let item = JSON.parse(JSON.stringify(this.userHoliday.holidayLibrary[index]));
        if (item.type!=null && item.desc!=null  && item.amount!=null){
          item.coachId = this.userHoliday.coachId;
          updateHolidayRemaining(item).then(val=>{
            if (val.status==200){
              this.userHoliday.holidayLibrary[index].type = null;
              this.userHoliday.holidayLibrary[index].desc = null;
              this.userHoliday.holidayLibrary[index].amount = null;
              this.userHoliday = JSON.parse(JSON.stringify(this.userHoliday));
              this.$message({message: '修改成功！', type: 'success'});
              this.updateHolidayDialog = false;
              this.selectHolidayDialog = false;
              this.selectLog();
              this.$emit("refresh");
            }else {
              this.$message.error('修改失败！');
            }
          })
        }
      })
    },
  }
}
</script>

<style scoped>
.update-holiday{
  margin: 30px 20px 30px 10px;
  background-color: #FAFCFF;
  border-radius: 14px;
  padding: 20px;
}
.transition-box {
  margin-bottom: 10px;
  width: 200px;
  height: 100px;
  border-radius: 4px;
  background-color: #409EFF;
  text-align: center;
  color: #fff;
  padding: 40px 20px;
  box-sizing: border-box;
  margin-right: 20px;
}
.amount-add{
  position: absolute;
  top: 34px;
  right: 10px;
  color: white;font-size: 14px;
  font-weight: bold;
  background-color: #67C23A;width: 40px;
  text-align: center;
  border-radius: 10px;
  padding: 2px 0
}
.amount-minus{
  position: absolute;
  top: 34px;
  right: 10px;
  color: white;font-size: 14px;
  font-weight: bold;
  background-color: #ffc061;width: 40px;
  text-align: center;
  border-radius: 10px;
  padding: 2px 0
}
</style>